import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCanonicalComponent } from './simple-icons-canonical.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCanonicalComponent ],
    exports:      [ SimpleIconsCanonicalComponent ],
    bootstrap:    []
})
export class SimpleIconsCanonicalModule {}
